<template>
  <v-dialog v-model="eventSoldout" max-width="600px" persistent>
    <v-card class="rounded-lg">
      <v-toolbar elevation="0">
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="eventSoldout = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12" v-for="(event, index) in events" :key="index">
            <v-card class="rounded-lg" elevation="0">
              <v-card-text style="position: relative; overflow: hidden">
                <v-row>
                  <v-col cols="3">
                    <v-img
                      :src="event.img"
                      width="160"
                      height="120"
                      class="rounded-lg"
                    />
                  </v-col>
                  <v-col class="d-flex flex-column text-left px-0">
                    <div class="sold-out-event elevation-3">Esgotado</div>
                    <span class="text-subtitle-1 font-weight-bold">
                      {{ event.descricao }}</span
                    >
                    <span>
                      O evento selecionado está esgotado, por favor remova o
                      evento para continuar.
                    </span>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-divider></v-divider>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="dark"
          class="rounded-lg"
          text
          @click="eventSoldout = false"
        >
          Cancelar
        </v-btn>
        <v-btn color="primary" class="rounded-lg" @click="removeEvents">
          Remover eventos e salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "eventsSoldoutModal",
  props: {
    events: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      eventSoldout: false,
    };
  },
  methods: {
    ...mapActions(["removeProductFromCart"]),
    removeEvents() {
      this.events.forEach(event => {
        this.removeProductFromCart(event);
      });
      this.eventSoldout = false;
      this.$emit("removeEvents");
    },
  },
  watch: {
    events: {
      handler() {
        if (this.events.length > 0) {
          this.eventSoldout = true;
        }
      },
      immediate: true,
    },
  },
};
</script>
<style scoped>
.sold-out-event {
  position: absolute;
  top: 0.5rem;
  left: -1.5rem;
  background-color: #f44336;
  color: #fff;
  padding: 2px 28px;
  margin-top: 10px;
  font-size: 15px;
  font-weight: bold;
  border-radius: 4px;
  transform: rotate(-45deg);
}
</style>
